import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './newsletter.component.scss';
var Newsletter = /** @class */ (function (_super) {
    tslib_1.__extends(Newsletter, _super);
    function Newsletter(element) {
        return _super.call(this, element) || this;
    }
    Newsletter.prototype.init = function () {
        // small newsletter
        this.submitButtonSmall = this.element.querySelector('.js-newsletter-submit-small');
        this.containerDetailsText = this.element.querySelector('.newsletter__details--text');
        this.containerDetailsForm = this.element.querySelector('.newsletter__details--form');
        this.containerDetailsCompleted = this.element.querySelector('.newsletter__details--completed');
        this.textHeading = this.element.querySelector('.js-newsletter-small-heading');
        this.textDescription = this.element.querySelector('.js-newsletter-small-description');
        this.fieldEmail = this.element.querySelector('.js-newsletter-small-email');
        this.buttonDone = this.element.querySelector('.js-newsletter-small-done');
        var checkStorage = localStorage.getItem('newsletter-entry');
        if (checkStorage) {
            this.storage = checkStorage;
        }
        this.checkNewsletterEntry();
        // modal newsletter
        this.forms = Array.from(this.element.querySelectorAll('form'));
        this.containerModalForm = this.element.querySelector('.newsletter__container-modal--form');
        this.containerModalLoader = this.element.querySelector('.newsletter__container-modal--loader');
        this.containerModalSuccess = this.element.querySelector('.newsletter__container-modal--success');
        this.modalButtons = Array.from(this.element.querySelectorAll('.js-newsletter-modal-open'));
        this.modalButtonsClose = Array.from(this.element.querySelectorAll('.js-newsletter-modal-close'));
        this.modalContainers = Array.from(this.element.querySelectorAll('.js-newsletter-modal'));
        this.checkboxes = Array.from(this.element.querySelectorAll('.js-newsletter-modal-checkbox'));
        this.submitButtonModal = Array.from(this.element.querySelectorAll('.js-newsletter-submit-modal'));
        this.buttonSelectAll = Array.from(this.element.querySelectorAll('.js-newsletter-selectall'));
        this.buttonSelectClear = Array.from(this.element.querySelectorAll('.js-newsletter-clearselected'));
        this.selectedCheckboxes = [];
        this.sitename = newsLetterSiteName;
        TooltipsService.initTooltips();
    };
    Newsletter.prototype.bindEvents = function () {
        var _this = this;
        // small newsletter
        if (this.submitButtonSmall) {
            this.submitButtonSmall.addEventListener('click', function (event) {
                var element = event.target;
                var form = element.closest('form');
                var formFields = form.querySelectorAll('input, select');
                var validation = _this.validationService.validate(formFields);
                if (typeof validation === 'object') {
                    if (validation.valid) {
                        _this.actionSmallNewsletter(form);
                    }
                }
                else {
                    var valid = Array.from(form.querySelectorAll(".form__group--error"));
                    if (valid.length == 0) {
                        _this.actionSmallNewsletter(form);
                    }
                }
            });
        }
        if (this.buttonDone) {
            this.buttonDone.addEventListener('click', function (event) {
                _this.containerDetailsCompleted.classList.remove('d-block');
                _this.containerDetailsCompleted.classList.add('d-none');
                _this.containerDetailsText.classList.remove('d-none');
                _this.containerDetailsText.classList.add('d-block');
                _this.containerDetailsForm.classList.remove('d-none');
                _this.containerDetailsForm.classList.add('d-block');
                _this.resetForms();
            });
        }
        // modal newsletter
        if (this.modalButtons) {
            this.modalButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                _this.formId = element.getAttribute('data-modal');
                _this.openModal(element.getAttribute('data-modal'));
            }); });
        }
        if (this.modalButtonsClose) {
            this.modalButtonsClose.map(function (item) { return item.addEventListener('click', function (event) {
                _this.analyticsService.dtmFormAbandon();
                _this.modalContainers.map(function (item) {
                    item.classList.add('modal--close');
                    setTimeout(function () {
                        item.classList.add('modal--closed');
                        item.classList.remove('modal--close');
                        _this.resetForms();
                    }, 250);
                });
            }); });
        }
        if (this.modalContainers) {
            this.modalContainers.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                if (element.getAttribute('id') === _this.activeModal) {
                    _this.analyticsService.dtmFormAbandon();
                    _this.modalContainers.map(function (item) {
                        item.classList.add('modal--close');
                        setTimeout(function () {
                            item.classList.add('modal--closed');
                            item.classList.remove('modal--close');
                            _this.resetForms();
                        }, 250);
                    });
                }
            }); });
        }
        if (this.buttonSelectAll) {
            this.buttonSelectAll.map(function (item) { return item.addEventListener('click', function (event) {
                _this.checkboxes.map(function (checkbox) {
                    checkbox.checked = true;
                });
                _this.buttonSelectClear.map(function (button) {
                    button.classList.add('d-block');
                });
                _this.submitButtonModal.map(function (button) {
                });
                _this.submitButtonModal.map(function (button) {
                    button.classList.remove('button--disabled');
                });
            }); });
        }
        if (this.buttonSelectClear) {
            this.buttonSelectClear.map(function (item) { return item.addEventListener('click', function (event) {
                _this.checkboxes.map(function (checkbox) {
                    checkbox.checked = false;
                });
                _this.buttonSelectClear.map(function (button) {
                    button.classList.remove('d-block');
                });
                _this.submitButtonModal.map(function (button) {
                    button.classList.add('button--disabled');
                });
            }); });
        }
        if (this.submitButtonModal) {
            this.submitButtonModal.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                if (!element.classList.contains('button--disabled')) {
                    var form = element.closest('form');
                    var formFields = form.querySelectorAll('input, select');
                    var formFieldsArray = [];
                    for (var index = 0; index < formFields.length; index++) {
                        var elementInput = formFields[index];
                        if (elementInput.getAttribute('type') !== 'checkbox') {
                            formFieldsArray.push(elementInput);
                        }
                    }
                    var validation = _this.validationService.validate(formFieldsArray);
                    if (typeof validation === 'object') {
                        if (validation.valid) {
                            _this.actionModalNewsletter(form);
                        }
                    }
                    else {
                        var valid = Array.from(form.querySelectorAll(".form__group--error"));
                        if (valid.length == 0) {
                            _this.actionModalNewsletter(form);
                        }
                    }
                }
            }); });
        }
        if (this.checkboxes) {
            var selectedCheckboxes = this.selectedCheckboxes;
            this.checkboxes.map(function (checkbox) { return checkbox.addEventListener('click', function (event) {
                // CHECK IF ALL IS CHECKED
                var element = event.target;
                if (element.value === 'all') {
                    if (element.checked) {
                        _this.checkboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = true;
                            }
                        });
                    }
                    else {
                        _this.checkboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = false;
                            }
                        });
                    }
                }
                else {
                    _this.checkboxes.map(function (checkbox) {
                        if (checkbox.value === 'all') {
                            checkbox.checked = false;
                        }
                    });
                }
                // VALIDATION
                var valid = false;
                _this.checkboxes.map(function (item) {
                    if (item.checked) {
                        valid = true;
                    }
                });
                if (valid) {
                    if (_this.buttonSelectClear) {
                        _this.buttonSelectClear.map(function (button) {
                            button.classList.add('d-block');
                        });
                    }
                    if (_this.submitButtonModal) {
                        _this.submitButtonModal.map(function (button) {
                            button.classList.remove('button--disabled');
                        });
                    }
                }
                else {
                    _this.submitButtonModal.map(function (button) {
                        button.classList.add('button--disabled');
                    });
                }
            }); });
        }
    };
    Newsletter.prototype.openModal = function (modalName) {
        var _this = this;
        if (modalName === void 0) { modalName = ''; }
        this.modalContainers.map(function (item) {
            var itemId = item.getAttribute('id');
            item.classList.remove('modal--open');
            item.classList.add('modal--closed');
            if (modalName) {
                if (modalName === itemId) {
                    _this.activeModal = modalName;
                    item.classList.remove('modal--closed');
                    item.classList.add('modal--open');
                }
            }
        });
    };
    Newsletter.prototype.setNewsletterEntry = function () {
        if (!this.storage) {
            this.containerDetailsText.classList.remove('d-block');
            this.containerDetailsText.classList.add('d-none');
            this.containerDetailsForm.classList.remove('d-block');
            this.containerDetailsForm.classList.add('d-none');
            this.containerDetailsCompleted.classList.remove('d-none');
            this.containerDetailsCompleted.classList.add('d-block');
            localStorage.setItem('newsletter-entry', 'true');
            this.storage = localStorage.getItem('newsletter-entry');
            this.checkNewsletterEntry();
        }
        else if (this.storage) {
            this.containerDetailsText.classList.remove('d-block');
            this.containerDetailsText.classList.add('d-none');
            this.containerDetailsForm.classList.remove('d-block');
            this.containerDetailsForm.classList.add('d-none');
            this.containerDetailsCompleted.classList.remove('d-none');
            this.containerDetailsCompleted.classList.add('d-block');
        }
        else {
            this.checkNewsletterEntry();
        }
    };
    Newsletter.prototype.checkNewsletterEntry = function () {
        if (this.storage) {
            if (this.textHeading) {
                this.textHeading.innerHTML = "You are already subscribed!";
            }
            if (this.textDescription) {
                this.textDescription.innerHTML = "Try signing up with a different email address";
            }
        }
    };
    Newsletter.prototype.actionSmallNewsletter = function (form) {
        var _this = this;
        var operation = "subscribeBasic";
        var formId = 'newsletter-simple';
        var site = this.sitename;
        var email = form.querySelector('input.js-newsletter-small-email').value;
        var formRow = form.querySelector('div.row');
        formRow.classList.add('d-none');
        var createLoader = document.createElement('div');
        createLoader.innerHTML = '<img class="search__results-busy" src="/file_source/assets/img/spinner.gif">';
        form.appendChild(createLoader);
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (email) {
            postData += 'email=' + email + '&';
        }
        if (site) {
            postData += 'site=' + site + '&';
        }
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            form.querySelector('.search__results-busy').remove();
            formRow.classList.remove('d-none');
            analyticsService.dtmFormComplete('complete', response.data.subscriberId);
            var resultApi = response.data.result;
            if (resultApi.includes('already')) {
                localStorage.setItem('newsletter-entry', 'true');
                _this.storage = localStorage.getItem('newsletter-entry');
                _this.checkNewsletterEntry();
            }
            else {
                if (!_this.storage) {
                    _this.containerDetailsText.classList.remove('d-block');
                    _this.containerDetailsText.classList.add('d-none');
                    _this.containerDetailsForm.classList.remove('d-block');
                    _this.containerDetailsForm.classList.add('d-none');
                    _this.containerDetailsCompleted.classList.remove('d-none');
                    _this.containerDetailsCompleted.classList.add('d-block');
                    localStorage.setItem('newsletter-entry', 'true');
                    _this.storage = localStorage.getItem('newsletter-entry');
                    _this.checkNewsletterEntry();
                }
                else if (_this.storage) {
                    _this.containerDetailsText.classList.remove('d-block');
                    _this.containerDetailsText.classList.add('d-none');
                    _this.containerDetailsForm.classList.remove('d-block');
                    _this.containerDetailsForm.classList.add('d-none');
                    _this.containerDetailsCompleted.classList.remove('d-none');
                    _this.containerDetailsCompleted.classList.add('d-block');
                }
                else {
                    _this.checkNewsletterEntry();
                }
            }
        }).catch(function (error) {
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            console.log(error);
        });
    };
    Newsletter.prototype.actionModalNewsletter = function (form) {
        var _this = this;
        var operation = "subscribe";
        var formId = this.formId;
        var site = this.sitename;
        var firstName = form.querySelector('input.js-modal-newsletter-firstName').value;
        var surname = form.querySelector('input.js-modal-newsletter-surname').value;
        var email = form.querySelector('input.js-modal-newsletter-email').value;
        var contact = '';
        if (form.querySelector('input.js-modal-newsletter-contact')) {
            contact = form.querySelector('input.js-modal-newsletter-contact').value;
        }
        var topics = "";
        var topicsDataLayer = "";
        this.selectedCheckboxes = [];
        this.checkboxes.map(function (item) {
            if (item.checked) {
                if (item.value !== 'all') {
                    _this.selectedCheckboxes.push(item.value);
                }
            }
        });
        var arrayCheckboxesEmpty = [];
        var arrayCheckboxes = this.selectedCheckboxes;
        for (var index = 0; index < arrayCheckboxes.length; index++) {
            var topic = arrayCheckboxes[index];
            if (!arrayCheckboxesEmpty.includes(topic)) {
                if ((index + 1) === arrayCheckboxes.length) {
                    topics += topic;
                    topicsDataLayer += topic;
                    arrayCheckboxesEmpty.push(topic);
                }
                else {
                    topics += topic + ",";
                    topicsDataLayer += topic + ":";
                    arrayCheckboxesEmpty.push(topic);
                }
            }
        }
        dataLayer.formOptions = topicsDataLayer;
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (firstName) {
            postData += 'firstName=' + firstName + '&';
        }
        if (surname) {
            postData += 'surname=' + surname + '&';
        }
        if (email) {
            postData += 'email=' + email + '&';
        }
        if (contact) {
            postData += 'contact=' + contact + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        if (site) {
            postData += 'site=' + site + '&';
        }
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            localStorage.setItem('sbgNewsletterSubscriberId', response.data.subscriberId);
            analyticsService.dtmFormComplete('complete', response.data.subscriberId);
        }).catch(function (error) {
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            console.log(error);
        });
        this.containerModalForm.classList.add('d-none');
        this.containerModalLoader.classList.remove('d-none');
        setTimeout(function () {
            _this.containerModalLoader.classList.add('d-none');
            _this.containerModalSuccess.classList.remove('d-none');
        }, 2000);
    };
    Newsletter.prototype.resetForms = function () {
        if (this.forms) {
            this.forms.map(function (form) {
                form.reset();
                var formGroups = Array.from(form.querySelectorAll('.form__group--error'));
                formGroups.map(function (formGroup) {
                    formGroup.classList.remove('form__group--error');
                });
            });
        }
        this.buttonSelectClear.map(function (button) {
            button.classList.remove('d-block');
        });
        this.submitButtonModal.map(function (button) {
            button.classList.add('button--disabled');
        });
        if (this.containerModalSuccess) {
            this.containerModalSuccess.classList.add('d-none');
        }
        if (this.containerModalForm) {
            this.containerModalForm.classList.remove('d-none');
        }
    };
    return Newsletter;
}(Base));
export { Newsletter };



//////////////////
// WEBPACK FOOTER
// ./components/newsletter/newsletter.component.ts
// module id = 417
// module chunks = 0